import { Controller } from "@hotwired/stimulus";
import { fillInput, selectOptionFor } from "../../utils/inputs_utils";
import { removeTableRow } from "../../components/tables/remove_table_row";

export default class extends Controller {
  static targets = ["invoiceDate", "invoiceSupplier", "invoiceCurrency", "invoiceAmount", "invoiceVat"];

  connect() {
    this.element.addEventListener("accountingDocument:processedFormReady", (e) => {
      this._fillForm(e.detail.purchase_invoice);
    });

    document.addEventListener("accountingDocument:validated", (e) => {
      if (this._isEmptyStatePage()) {
        location.reload();
        return;
      }

      document.dispatchEvent(
        new CustomEvent("purchaseInvoice:updated", { detail: { purchaseInvoices: e.detail.purchase_invoices } })
      );
    });

    document.addEventListener("accountingDocument:removed", (e) => {
      const deletedPurchaseId = e.detail.id;
      removeTableRow(deletedPurchaseId);
    });
  }

  _fillForm(purchaseInvoice = {}) {
    const { date, supplier, currency, original_amount, vat } = purchaseInvoice;

    fillInput(this.invoiceDateTarget, date);
    fillInput(this.invoiceSupplierTarget, supplier);
    selectOptionFor(this.invoiceCurrencyTarget, currency);
    fillInput(this.invoiceAmountTarget, original_amount);
    fillInput(this.invoiceVatTarget, vat);
  }

  _isEmptyStatePage() {
    return document.querySelector(".empty-state");
  }
}
